import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ProductBoxModel } from 'src/app/_models/product-box.model';
import { BoxesService } from 'src/app/_services/boxes.service';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/_services/loading.service';

@Component({
  selector: 'edit-box-config',
  templateUrl: './edit-box-config.component.html',
  styleUrls: ['./edit-box-config.component.scss']
})
export class EditBoxConfigComponent implements OnInit {
  @Input() box: ProductBoxModel;
  @Input() prodData;
  @Input() title?: string;

  configForm: UntypedFormGroup;
  imageUrl: string = environment.baseUrl + '/products/image/';

  constructor(public activeModal: NgbActiveModal,
    private boxesService: BoxesService,
    private toastr: ToastrService,
    private fb: UntypedFormBuilder,
    private loadingService: LoadingService) { }


  ngOnInit() {
    this.configForm = this.fb.group({
      name: [this.box.name, Validators.required],
      quantity: [this.box.quantity, this.prodData ? [Validators.required, Validators.min(1),
        Validators.pattern(/^(0|[1-9]\d*)?$/)] : [Validators.min(1), Validators.pattern(/^(0|[1-9]\d*)?$/)]],
      width: [this.box.width, this.prodData ? [Validators.min(0.01), Validators.pattern(/^\d+(\.\d{1,2})?$/)]
        : [Validators.required, Validators.min(0.01), Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      height: [this.box.height, this.prodData ? [Validators.min(0.01), Validators.pattern(/^\d+(\.\d{1,2})?$/)]
        : [Validators.required, Validators.min(0.01), Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      depth: [this.box.depth, this.prodData ? [Validators.min(0.01), Validators.pattern(/^\d+(\.\d{1,2})?$/)]
        : [Validators.required, Validators.min(0.01), Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      weight: [this.box.weight, [Validators.min(0.01), Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
    });
  }

  submit() {
    if (this.configForm.invalid) {
      this.configForm.markAllAsTouched();
      return;
    }
    let controls = this.configForm.controls;
    for (let ctrlName of Object.keys(controls))
      this.box[ctrlName] = controls[ctrlName].value;
    this.loadingService.loading = true;
    if (this.prodData) {
      if (this.box.id > 0)
        this.boxesService.updateProductBox(this.box).subscribe(res => this.boxUpdated(res));
      else if (this.box.productId)
        this.boxesService.createProductBox(this.box).subscribe(res => this.boxUpdated(res));
      else {
        this.loadingService.loading = false;
        this.activeModal.close(this.box);
      }
    } else {
      if (this.box.id > 0)
        this.boxesService.updateBox(this.box).subscribe(res => this.boxUpdated(res));
      else
        this.boxesService.createBox(this.box).subscribe(res => this.boxUpdated(res));
    }
  }

  boxUpdated(newBox: any) {
    let action: string = 'updated';
    if (this.box.id != newBox.id) {
      this.box.id = newBox.id;
      action = 'added';
    }
    this.box.isDefault = newBox.isDefault;
    this.loadingService.loading = false;
    this.toastr.success(`The box configuration "${this.box.name}" has been ${action}`);
    this.activeModal.close(this.box);
  }
}
